export default __webpack_public_path__ + "static/media/cancel.09dd9095.svg";